export const CHECKOUT_API_ROUTES = {
    GET_STUDENT_PLAN_DETAILS: 'subscription/studentplandetails',
    SUBMIT_COUPON_CODE: 'subscription/SubmitCouponCode',
    SUBSCRIBE_STUDENT_PLAN: 'subscription/subscribeStudentPlan',
    SUBSCRIBE_STUDENT_PLAN_PAYMENT: '/subscription/createOrder',
}
